// angular
//     .module("HeroPRO")
//     .controller("ContactInfoController", ContactInfoController);


import './contactInfo.scss';

/* @ngInject */
class ContractInfoController {
    constructor(UserData, TopNavFactory) {
        const vm = this; // switch to => case don't need to do this anymore (PUN)

        vm.contactInfo = { phone: null, callHours: null }; // Added to prevent trying to read contactInfo off undefined object.

        TopNavFactory.getContactHours().then((response) => {
            const hours = response.data.Data;

            vm.contactInfo = {
                phone: '844-722-7759',
                callHours: hours,
            };
        });

        UserData.getCurrentLocation().then((response) => {
            if (response.ContractorStatusId === 10) {
                this.contactInfo.phone = '844-928-8327';
            }
        });
    }
}

export default ['UserData', 'TopNavFactory', ContractInfoController];



// WEBPACK FOOTER //
// ./src/app/common/topNav/contactInfoController.js